import * as React from 'react';



export interface IStepNumberDividerProps {
  number: number;
  total: number;
}

export default class StepNumberDivider extends React.Component<
  IStepNumberDividerProps,
  {}
> {
  static defaultProps: IStepNumberDividerProps = {
    number: 1,
    total: 3
  };

  render(): React.ReactNode {
    return (
      <div className="step-number-container">
        <div className="step-number-line" />
        <span>
          Step {this.props.number} of {this.props.total}
        </span>
        <div className="step-number-line" />
      </div>
    );
  }
}
